export default "__VITE_ASSET__78627936__"